import React from 'react';
import classes from './RemotePage.module.css'
import Title from '../../Component/Title/Title';
import InOfficeButton from '../../Component/buttons/InOfficeButton/InOfficeButton';
import {useNavigate} from 'react-router-dom';
import {markAsOffice} from '../../apiClient/apiClient';

const RemotePage = ({tg}) => {
  const chatId = tg.initDataUnsafe?.user?.id ?? 123456;

  const navigate = useNavigate();

  const markAsOfficeAction = async (event) => {
    const response = await markAsOffice(chatId);
    if (response === 'error') {
      throw new Error('MarkAsOffice Error');
    }

    navigate('/');
  }

  return (
    <div className={classes.remotePage}>

      <div className={classes.infoBlock}>
        <Title/>

        <div className={classes.textBlock}>

        <span className={classes.textFirst}>
          Ты отметил(а) что сегодня работаешь удаленно, так что не будешь получать уведомления о перекурах и не сможешь их инициировать.
        </span>

          <span className={classes.textSecond}>
          Если хочешь снова участвовать в перекурах, нажми кнопку ниже :)
        </span>

        </div>
      </div>


      <InOfficeButton onClickAction={markAsOfficeAction}/>

    </div>
  );
};

export default RemotePage;